import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from '../logout';

export const initialState = {
  loaded: false,
  packages: null,
  roles: null,
  countries: null,
  deliveryTerm: null,
  userType: null,
  cities: null,
};

const globalsSlice = createSlice({
  name: 'globals',
  initialState,
  reducers: {
    fetch: (state) => {
      state.loaded = false;
    },
    fetchCities: (state) => {
      state.loaded = false;
    },
    success: (state, action) => {
      state.packages = action.payload.packages;
      state.countries = action.payload.countries;
      state.cities = action.payload.cities;
      state.roles = action.payload.roles;
      state.deliveryTerm = action.payload.deliveryTerm;
      state.notifierType = action.payload.notifierType;
      state.userType = action.payload.userType;
    },
    fetchCitiesSuccess: (state, action) => {
      state.loaded = true;
      state.cities = action.payload;
    },
    failure: (state) => {
      state.loaded = true;
    },
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, actions, reducer } = globalsSlice;
